import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth38: ToothDataEntry = {
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.4,167l-1.9-17.8-15.3-56.5-1.5-14.2v-9c.1,0,1.8-9,1.8-9l1.8-6.3,3.2-5.8,1.6-2.4,2.9-1.3,4.3-.2,4.6.7,3.3.8,18.3-7.3,16.9-3.3,18.4,4.6,41.8,2.9,20.1,10.8,3.9,2.9,3.3.9,8.1,4.3,15.6-.5,6.3,3.2,3.6,6.8.8,6.6.4,5.5-.2,14-1.1,13.1-1.7,10.3-2.8,14-4.4,15.7-5.1,12.7-2.7,5.9-3.3,6.8c-80.1,27.1-141.1-8.9-141.1-8.9Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M115.7,137.8a17,17 0 1,1 -34,0a17,17 0 1,1 34,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.2,159.4s21,1,27.2,1.1,11-3.9,11.1-11.2,1.4-113.5,1.4-113.5l-19.3,3.3-15.6,7-6.3-1.2-5.6.5-3.1,1-3.4,3.6-2,5.8-1.6,6.1-.8,8.3v14.7s2.5,14.3,2.5,14.3l15.6,60.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M137.6,50.2l18.5,11.6h7.3c0,0,11.1-.7,11.1-.7l8.1,5.1,3.1,7.6,1,13.4-1.7,18-1.9,18.9-4,17.7-2.7,8.5-6.3,16.3-22.4-1.3c-6.2,0-10.7-4.2-10.7-10.5-2.5-25.7.7-104.6.7-104.6h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.4,167v-10.8s-1.7-13.5-1.7-13.5L6.2,85v-14.7s.9-8.3.9-8.3l1.6-6.1,2-5.8,3.4-3.6,3.2-1h0s5.6-.5,5.6-.5l6.3,1.2,10.5-3.8,8.4-2.5,9.3-2.8,7.3-1.1,19,4.9c-8.8,31.4,20.9,120.4,3.5,144.2-38.2-3.4-62.5-18-62.5-18Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.9,185c17.2-29.6-13-113.1-3.4-144.3l26.5,1.4,16.4,1.3h0s29.8,18.4,29.8,18.4h7.3c0,0,11.1-.7,11.1-.7l8.1,5.1,3.1,7.6,1,13.4-1.7,18-1.9,18.9-4,17.7-2.7,8.5-6.3,16.3-4.5,9.4c-41.7,14.3-78.6,9.1-78.6,9.1Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.4,167s60.4,35.6,141.1,8.9l-4.1,13.2s-54.3,29.2-136.7-7.4l-.2-14.8Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.8 102.7 30.8 127.7 36.2 86.7 53.6 135.6 66.6 86.7 82.8 138.1 97.7 89.8 113.9 138.1 128.3 89.2 143.8 138.1 155.6 90.5 164.6 129.7 182.7 101.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'128 184 116.8 191.4 130.6 198.5 119.3 206 132.1 212.6 121.4 219.7 132.8 225.6 122.4 232.5 135.6 239.2 125.3 245.9 135.9 251.3 125.7 258 137.2 263.9 126.4 271.1 137.2 276.5 126.4 283.7 136.6 289 126 295.9 138.3 302.1 125.9 310.3 137.7 316.5 125.5 324.4 137.8 330.7 125.7 338.6 139.6 345.8 128.6 353.1 141.5 359.7 128.4 368.3 140.6 374.6 128.8 382.4 141.8 389 129.2 397.3 142 403.9 129.5 414.8',
				'75.2 410.8 72.5 399.2 60 399.2 63.3 388.6 48.9 384.9 58.6 375.2 42.2 368.7 54.5 362.4 41.3 353.8 54.2 347.1 43.2 339.8 57.1 332.7 45 324.8 57.3 318.5 45.1 310.5 56.9 304.3 44.5 296.2 56.8 289.9 46.3 283 56.4 277.7 45.6 270.6 56.4 265.1 45.6 258 57.2 252.1 46.9 245.4 57.5 240 47.2 233.3 60.4 226.6 50 219.6 61.5 213.8 50.7 206.6 63.5 200 52.2 192.5 66 185.5 54.8 178.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'20.6 293.9 35.8 310.2 50.4 293.6 67.8 311.7 85.6 293.6 100.4 312.5 116.6 296.7 130.3 310.2 141.7 295.6 152.4 311.7 162 296.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '21.8 159 11.6 143.5 9.3 126.4 9.7 92.4 11.6 80.3 17.2 64.9 27.8 54.4 43.9 47.8 59.3 44.8 76.3 45.2 108.8 37.4 132.1 36.9 164.1 47.4 178.4 61.1 184.3 76 186.9 126.4 184.4 137.2 173.6 170 161.7 182.8 147 189.2 132.5 194 122.6 196 95.8 196.2 78.2 194.1 56.5 186.2 21.8 159',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M50.7,88.3l16.9,9s14.7,7.8,0,18.5c-4.2,3-13.6,9.8-13.6,9.8l-37.1,24.9-5.5-6.8-1.8-14.6-.3-28.9,1.3-11.7,1-9.9,3.6-9.1,35.5,18.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180,67.9l-27.3,23.5-9.7,8.2s-12,6.8-2.2,17.9l8.3,12.5,24.2,36.4c9-6.6,12.9-40.5,12.9-40.5l-.3-36.4-1.8-11.3-2.1-7s-1.9-3.2-1.9-3.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M149.2,130s-22.1-10-26.2-7.9c-1.6.8-5,4.1-8.6,19.8s6.7,54.2,6.7,54.2l14.3-2.6,7.9-2.3,8.3-3.8,5.2-3.1,5-1.2,10.9-11.2.5-5.4-24.2-36.4Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.8,150.5l37.1-24.9s23-5.9,40,8.3c16.9,14.3,22.6-10.5,29-11.9s-4.7,1.4-8.4,19.9c-2.7,16.8,2.9,39.3,6.7,54.2h-25.4c0,0-18.4-2.6-18.4-2.6l-20.9-7.3-27.2-20.7-7.5-6.5-5-8.5Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M15.4,69.5l4.4-6.6,8.3-8.4,15.1-6.3,16-3.4,17.9.2,17.2-3.3s4.7,14.5,5.3,22.2c-2.6,8.4,4.6,20.6,4.6,20.6-20.2-1.1-23.2,18.9-53.6,3.8l-35.5-18.8h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.5,41.7l14.3-4.3,23.3-.4,6.9,2.7,9.2,2.3,8.3,3.1,7.6,2.2,4.7,5.2,4.5,3.5,5.1,5,1.6,6.8-27.3,23.5s-11.9,2.9-15.9,3.4-8,.5-13.8-4.4c-5.8-5-18.7-5.8-18.7-5.8-5.1-9.4-6.3-15.4-4.6-20.6,0,0-.6-6-5.2-22.3h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.2,91.5c22.4,8.3,30.1-8.8,46.1-7,5.3.6,13.7,1.8,18.7,5.8,4.7,3.8,8.2,5.3,13.8,4.4l15.9-3.4c-.2,3.7-23.8,11.8-11.9,26.1l8.3,12.5s-19.9-9.2-26.2-7.9c-1.7-.3-8.2,10-11.4,13-8.6,7.8-16.1.4-17.6-1.1-20.6-13.8-40-8.3-40-8.3,0,0,10.3-7.6,13.7-10,12.4-9.5,4.6-15.6-5.1-20.9s-11.9-6.4-11.9-6.4l7.5,3.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'11.3 102.9 32.8 128 39.4 88.3 55.1 136.4 69.8 89.2 84.3 139.8 100.6 93.1 115.3 140.8 131.1 93.4 145.3 141.7 158.5 95.5 166.4 133.8 185.1 107',
			],
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M153.3,354.1l2.6,5.6,5.5,18.6,2.9,18.1.4,13.7v12.2s-1.7,8.8-1.7,8.8l-3.5,12.1-7,11.8-9.1,9-15,4.8-14.7-2-30.7-3.1-16.1,5.7-14.7,1.5-20.3-.2-10.7-4-7.5-6.3-4.7-8-3.9-14.8.2-10,1.5-12.3,3.5-14.4,14.3-46.4s32.3-18.9,129-.4Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.7,378.6a16.6,16.6 0 1,1 -33.2,0a16.6,16.6 0 1,1 33.2,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.5,368.5s-17,52.9-16,58.9c.9,5.7-5,40.5,32.9,43.1,9.1.6,12.3-.3,12.3-.3l4.2-87.5s2.6-12.1-7.8-13.6c-10.3-1.5-25.6-.7-25.6-.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M158.9,370.5s19,67.9-13.7,91.8c-4.3,4.9-17.2,5.2-17.2,5.2l-12.1-.6,4-84.4s-.6-11.2,9.5-11.2c10.1,0,29.5-.8,29.5-.8h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M156.6,359.9s29.6,64.8-10.8,102c-5.4,4.9-16.9,5.6-16.9,5.6l-44.1-3.9s-8.2-27.2,9.9-39.1c13.2-8.7-.9-78.1-.9-78.1,26,.8,60.5,7.7,60.5,7.7l2.3,5.8Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.3,357.3s-18.8,64.1-17.8,70.2c.9,5.7-4.9,39.5,32.9,43.1,21.9,2.2,46.3-7,46.3-7,0,0-8.2-27.1,9.9-39.1,13.1-7.9-.9-78.1-.9-78.1-52.3-2-69.4,8.1-69.4,8.1l-1,2.8Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.3,354.5s33.9-18.7,129-.4l-3.5-11.5s-68.2-13.2-122.7-2.4l-1.2,6.6-1.6,7.7Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.1 413.4 29.1 393.2 31.4 428.7 49.4 387.7 58.1 430.4 75.4 387.3 85.7 429.7 102.5 389.1 112.4 431.9 128.9 390.9 136.7 432.5 146.8 399.3 160.8 424.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'144.7 107.9 155.1 122.7 141 125.3 152.6 136.8 139.7 142.4 151.4 151.3 138.2 157 149.4 165.4 136.9 170.8 149.3 180.1 136.2 185.8 146.5 193.6 132.4 199.8 143.7 208.3 131.3 213.6 142.7 222.2 130.8 227.5 142.4 236.3 129.9 241.7 139.8 249.1 129.5 253.7 139.7 261.4 128.7 266 138.9 273.7 127.2 278.7 136.8 286 126.1 290.6 135.7 297.8 122.3 303.6 132.1 311 120.5 316 130.5 323.7 117.6 329.4 128.2 337.5 114.2 343.5 124.7 351.5',
				'52.5 352.6 64 346 50.9 338.2 62.5 331.6 50.4 324.3 61.4 318 50.5 311.5 61.2 305.4 48.7 297.9 59.2 292 49.1 286.1 59.6 280.1 48.7 273.7 59.7 267.3 49.5 261.3 60.5 255 50.9 249.1 61.7 243 50.1 236.1 62.7 228.9 51.6 222.1 64.1 215.1 52.4 208.1 64.7 201.2 51.6 193.3 62.9 186.8 50.6 179.4 64.1 171.9 52.5 164.9 64.6 158 53.2 147.1 65.1 143.3 59.7 131.1 74.6 130 70.8 119 84.2 110',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'160 247 151.9 231.3 140.4 246.5 130.3 231.4 116.2 243.8 101.4 227.3 85.9 244.9 69.8 225.9 51.8 242.6 38.8 225.4 23 240.4',
			],
		},
	},
};
